


























import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'
import Carousel from '@ui/Carousel'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RecapDisplay'

  vue:
    props: ['recap']

    components: {
      FormField,
      Carousel,
    }

    data: ->
      data: @recap

    computed:
      answers: ->
        RecapUtility.answers @data

      optionsForCarousel: ->
        perPage: if document.body.clientWidth < 768 then 2.25 else 3.5

    methods:
      displayQuestion: (question) ->
        RecapUtility.displayQuestion question, @data.answers

      isAnswered: (answer) ->
        RecapUtility.isAnswered answer

      labelForAnswer: (answer, question) ->
        RecapUtility.labelForAnswer answer, question

    watch:
      recap: (value) ->
        @data = value

export default VueOptions.vue settings
